import React, { FC } from 'react';

import { OnlyOneLeft } from 'components/OnlyOneLeft/OnlyOneLeft';
import { Prices } from 'components/Prices/Prices';
import { Season } from 'components/Season/Season';
import { fontFamilies } from 'components/UI/Font';
import { buildBrandUrl } from 'helpers/routes';
import { useUrlBuilder } from 'hooks/useUrlBuilder';
import { Product } from 'models/product';
import { useAppContext } from 'store/appContext';

export const ProductInfoCard: FC<{
  isLastOne: boolean;
  product: Product;
}> = ({ isLastOne, product }) => {
  const {
    department,
    paths: { admin: adminPath },
    productDetails: { canEdit },
  } = useAppContext();
  const { brand, formattedSeason, model, productId, productVersionId } = product;

  const { localized } = useUrlBuilder();
  const { name: brandName, url: brandUrl } = brand;
  const brandHref = localized(buildBrandUrl({ brandUrl, department }));

  return (
    <div className="product-info-card">
      {isLastOne && (
        <div className="only-one-left mobile">
          <OnlyOneLeft justifyContent="center" lineHeight="20px" />
        </div>
      )}
      <div className="season">
        <Season formattedSeason={formattedSeason} />
      </div>
      <h2 className="brand">
        {brandUrl ? (
          <a className={`brand-pr-${productId}`} href={brandHref}>
            {brandName}
          </a>
        ) : (
          <span>{brandName}</span>
        )}
      </h2>
      <h1 className="model">{model}</h1>

      {canEdit && adminPath && (
        <a href={`${adminPath}/admin/mkt_product/edit_product/${productId}#${productVersionId}`}>Edit</a>
      )}

      <Prices
        product={product}
        style={{
          beforeReductionPrice: { fontSize: '15px', marginBottom: '7px', spaceBeforeSaleText: '15px' },
          currentPrice: { fontSize: '24px', marginBottom: '4px' },
        }}
      />
      <style jsx>{`
        .product-info-card,
        :global(.product-info-card *) {
          font-size: 15px;
          text-align: center;
        }

        .model {
          line-height: 1;
          margin-bottom: 20px;
          font-family: ${fontFamilies.light};
          font-weight: normal;
          letter-spacing: inherit;
          text-transform: none;
        }

        @media (min-width: 1024px) {
          .product-info-card,
          :global(.product-info-card *) {
            text-align: left;
          }

          .season {
            margin-bottom: 5px;
          }

          .brand {
            margin-bottom: 10px;
          }

          .model {
            margin-bottom: 30px;
          }
        }

        .brand > * {
          line-height: 41px;
          height: 41px;
          font-size: 30px;
          text-transform: uppercase;
          font-family: ${fontFamilies.bold};
          letter-spacing: 1px;
        }

        .model,
        .model * {
          line-height: 1.2;
        }
      `}</style>
    </div>
  );
};
